import { memo } from "react"

import { BaseTopBar } from "../TopBars/BaseTopBar"

export const ProjectDocumentsViewTopBar = memo(() => {
	return <BaseTopBar />
})
ProjectDocumentsViewTopBar.displayName = "ProjectDocumentsViewTopBar"
